import type { IdentityFile, RequestOptions } from "core/types/api"
import { api } from "core/api"

export function getIdentityFiles() {
    return api.get<IdentityFile[]>("get_identity_files")
}

export function addIdentityFile(data: { name: string; pdf?: File }, options: RequestOptions = {}) {
    return api.post<IdentityFile>("add_identity_file", { data, ...options })
}

